import { SvgIcon } from '@mui/material'

const SvgTasks = (props) => (
  <SvgIcon viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" name="SvgTasks" {...props}>
    <style>
      {
        '.tasks_svg__st1{fill:#faa515}.tasks_svg__st3{fill:#e6e6e6}.tasks_svg__st4{fill:#50758d}.tasks_svg__st5{fill:#4caf50}'
      }
    </style>
    <path
      d="M54.728 6.181v56.531c0 .711-.577 1.288-1.288 1.288H10.559a1.288 1.288 0 01-1.288-1.288V6.181c0-.711.577-1.288 1.288-1.288H53.44c.711 0 1.288.577 1.288 1.288z"
      fill="#fad207"
    />
    <path
      className="tasks_svg__st1"
      d="M11.332 11.248v49.78c0 .504.408.912.912.912h25.983c.342 0 .669-.136.911-.377l9.925-9.925V10.559H13.898l-.217-1.567-1.776 1.185a1.288 1.288 0 00-.573 1.071z"
    />
    <path
      d="M50.865 10.044v39.791l-7.726 2.833-2.575 7.469H14.423a1.288 1.288 0 01-1.288-1.288V10.044c0-.711.577-1.288 1.288-1.288h35.155a1.288 1.288 0 011.287 1.288z"
      fill="#f5f5f5"
    />
    <path
      className="tasks_svg__st3"
      d="M50.865 49.835L40.563 60.137v-9.014c0-.711.577-1.288 1.288-1.288h9.014zM44.96 8.757v2.502a3.224 3.224 0 01-3.219 3.219H22.26a3.224 3.224 0 01-3.219-3.219V8.757H44.96z"
    />
    <path className="tasks_svg__st1" d="M19.04 4.893h25.92v3.863H19.04V4.893z" />
    <path
      className="tasks_svg__st4"
      d="M43.028 4.891v6.367c0 .711-.577 1.288-1.288 1.288H22.26a1.288 1.288 0 01-1.288-1.288V4.891h7.148a4.037 4.037 0 01-.086-1.287 3.983 3.983 0 117.846 1.287h7.148z"
    />
    <path
      className="tasks_svg__st5"
      d="M22.135 25.509a.962.962 0 01-.669-.27l-3.263-3.137a.966.966 0 011.339-1.393l2.535 2.438 3.976-4.514a.965.965 0 111.449 1.277l-4.643 5.271a.96.96 0 01-.685.326c-.012.002-.026.002-.039.002z"
    />
    <path className="tasks_svg__st4" d="M44.298 22.874h-13.65a.965.965 0 110-1.932h13.65a.965.965 0 110 1.932z" />
    <path
      className="tasks_svg__st5"
      d="M22.135 36.871a.962.962 0 01-.669-.27l-3.263-3.137a.966.966 0 011.339-1.393l2.537 2.439 3.983-4.503a.965.965 0 111.447 1.279l-4.65 5.257a.966.966 0 01-.684.325c-.014.003-.027.003-.04.003z"
    />
    <path
      className="tasks_svg__st4"
      d="M44.298 34.189h-13.65a.965.965 0 110-1.932h13.65a.965.965 0 110 1.932zM44.298 45.924h-2.254a.965.965 0 110-1.932h2.254a.965.965 0 110 1.932zM37.537 45.924h-6.889a.965.965 0 110-1.932h6.889a.965.965 0 110 1.932z"
    />
    <path
      d="M25.626 48.886h-5.924a.965.965 0 01-.966-.966v-5.924c0-.534.432-.966.966-.966h5.924c.534 0 .966.432.966.966v5.924a.966.966 0 01-.966.966zm-4.958-1.932h3.992v-3.992h-3.992v3.992z"
      fill="#f44336"
    />
  </SvgIcon>
)

export default SvgTasks
